import { render, staticRenderFns } from "./BoostSalesList.vue?vue&type=template&id=6fb29e49"
import script from "./BoostSalesList.vue?vue&type=script&lang=js"
export * from "./BoostSalesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports